export default __webpack_public_path__ + "static/media/Human2.d4019826.png";